import Vue from 'vue';
import Vuex from 'vuex';

import api from './modules/api';
import auth from './modules/auth';
import icons from './modules/icons';
import misc from './modules/misc';
import nav from './modules/nav';
import schedule from './modules/schedule';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    socket: {
      isConnected: true,
      message: '',
      reconnectError: false
    }
  },
  mutations: {
    SOCKET_ONOPEN (state, event) {
      console.log('--> Websocket up and running')
      state.socket.isConnected = true
      console.log(event)
    },
    SOCKET_ONCLOSE (state, event) {
      console.log('--> Websocket got closed')
      state.socket.isConnected = false
      console.log(event)
    },
    SOCKET_ONERROR (state, event) {
      console.error(state, event)
    },
    SOCKET_ONMESSAGE (state, message) {
      console.log('--> We got a new message!')
      console.log(message.data) // temp
      state.socket.message = JSON.parse(message.data)
    },
    SOCKET_RECONNECT (state, count) {
      console.log('--> Websocket got reconnected')
      console.info(state, count)
    },
    SOCKET_RECONNECT_ERROR (state) {
      console.log('we are back up and sailing guys! Nothing to worry about.')
      state.socket.reconnectError = true
    }
  },
  actions: {
    resetStore ({ dispatch }) {
      dispatch('resetAPI')
      dispatch('resetAuth')
      dispatch('resetMisc')
      dispatch('resetNav')
      dispatch('resetSchedule')
    }
  },
  modules: {
    api, auth, misc, nav, icons, schedule
  }
})
